import React, { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useClickOutside from 'Hooks/useClickOutside';
import useModal from 'Hooks/useModal';
import { selectUserName, selectUserRole } from 'store/Faraday/selectors';
import { selectIsOpen } from 'store/SideBar/selectorContext';
import { getUserData } from 'store/Settings/settingsActions';
import { selectUserEmail } from 'store/Settings/settingsSelectors';
import Settings from 'Screens/Contextualization/Settings';
import ColorImage from 'Common/Components/ColorImage';
import UserDropdown from './Dropdown';
import Extras from './Modals/Extras';
import About from './Modals/About';
import Help from './Modals/Help';
import {
  UserContainer,
  UserTrigger,
  AvatarSlot,
  UserInfo,
  UserName,
  UserInfoText
} from './styled';

const SideBarUser = () => {
  const dispatch = useDispatch();
  const [ModalPreferences, showModalPreferences, toggleModalPreferences] =
    useModal(Settings);
  const [ModalExtras, showModalExtras, toggleModalExtras] = useModal(Extras);
  const [ModalAbout, showModalAbout, toggleModalAbout] = useModal(About);
  const [ModalHelp, showModalHelp, toggleModalHelp] = useModal(Help);

  const [openMenu, setOpenMenu] = useState(false);
  const dataRef = useRef();
  useClickOutside(dataRef, () => setOpenMenu(false));

  useEffect(() => {
    if (
      showModalPreferences ||
      showModalExtras ||
      showModalAbout ||
      showModalHelp
    ) {
      setOpenMenu(false);
    }
  }, [showModalPreferences, showModalExtras, showModalAbout, showModalHelp]);

  useEffect(() => {
    dispatch(getUserData());
  }, [dispatch]);

  const isOpen = useSelector(selectIsOpen);
  const userRole = useSelector(selectUserRole);
  const userName = useSelector(selectUserName);
  const userEmail = useSelector(selectUserEmail);
  const roleLabel =
    userRole === 'admin' ? 'Administrator' : userRole?.replace(/[-_]/g, ' ');

  const modals = {
    Extras: {
      Modal: ModalExtras,
      showModal: showModalExtras,
      toggleModal: toggleModalExtras
    },
    About: {
      Modal: ModalAbout,
      showModal: showModalAbout,
      toggleModal: toggleModalAbout
    },
    Help: {
      Modal: ModalHelp,
      showModal: showModalHelp,
      toggleModal: toggleModalHelp
    },
    Preferences: {
      Modal: ModalPreferences,
      showModal: showModalPreferences,
      toggleModal: toggleModalPreferences
    }
  };

  return (
    <UserContainer ref={ dataRef }>
      <UserTrigger onClick={ () => setOpenMenu(!openMenu) } title={ userName }>
        <AvatarSlot>
          <ColorImage title={ userName } role={ userRole } />
        </AvatarSlot>
        {isOpen && (
          <UserInfo>
            <UserName children={ userName } />
            <UserInfoText children={ roleLabel } />
            <UserInfoText children={ userEmail } />
          </UserInfo>
        )}
        {openMenu && <UserDropdown modals={ modals } />}
      </UserTrigger>
      {modals.Preferences.showModal && (
        <modals.Preferences.Modal onClose={ modals.Preferences.toggleModal } />
      )}
      {modals.Extras.showModal && (
        <modals.Extras.Modal onClose={ modals.Extras.toggleModal } />
      )}
      {modals.About.showModal && (
        <modals.About.Modal onClose={ modals.About.toggleModal } />
      )}
      {modals.Help.showModal && (
        <modals.Help.Modal onClose={ modals.Help.toggleModal } />
      )}
    </UserContainer>
  );
};

export default SideBarUser;
